"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageUsageInteractor = void 0;
const interactors_1 = require("../interactors");
require("./StorageUsageLoadableModel");
class StorageUsageInteractor extends interactors_1.SynchronizingInteractor {
    static countTotalUsageBytes(data) {
        if (StorageUsageInteractor.isGcpModel(data)) {
            return data.standardUsage + data.archiveUsage;
        }
        if (StorageUsageInteractor.isAwsModel(data)) {
            return data.s3usage + data.glacierUsage + data.deepGlacierUsage;
        }
        if (StorageUsageInteractor.isAzureModel(data)) {
            return data.hotUsage + data.coolUsage + data.archiveUsage;
        }
        return 0;
    }
    static isGcpModel(model) {
        const gcpModelKeys = [
            'snapshotsCount',
            'snapshotsUsage',
            'backupsUsage',
            'archivesUsage',
            'standardUsage',
            'archiveUsage',
        ];
        return gcpModelKeys.every((key) => key in model);
    }
    static isAzureModel(model) {
        const azureModelKeys = [
            'snapshotsCount',
            'backupsUsage',
            'archivesUsage',
            'hotUsage',
            'coolUsage',
            'archiveUsage',
        ];
        return azureModelKeys.every((key) => key in model);
    }
    static isAwsModel(model) {
        const awsModelKeys = [
            'snapshotsCount',
            'replicasCount',
            'backupsUsage',
            'archivesUsage',
            's3usage',
            'glacierUsage',
            'deepGlacierUsage',
        ];
        return awsModelKeys.every((key) => key in model);
    }
}
exports.StorageUsageInteractor = StorageUsageInteractor;
//# sourceMappingURL=StorageUsageInteractor.js.map